
define('modules/application/wizard/steps/exportStep',[
  "app",

  // Libs
  "backbone",
  "jqueryUi",

  //Class
  "./regularStep"
],

function(app, Backbone, jQueryUi, RegularStep) {

  //Creating an event aggragatop
  var exportStepEventAggregator    = _.extend({}, Backbone.Events);


  //Extending regularStep views
  var exportStepViews           = _.extend({},RegularStep.Views);
  _.extend(exportStepViews, {

    Content  : RegularStep.Views.Content.extend({
      template     : "application/wizard/steps/export",
      initialize   : function() {
        for(var i=0;i<this.options.model.get("sections").length;i+=1) {
          var classToInstance = this.sectionInstancer(this.options.model.get("sections")[i]);
          var obj   = classToInstance;
          objModel  = new obj.Model({stepEventAggregator :   this.options.stepEventAggregator});
          this.insertView(".accordionView", new obj.Views.titleBar ({ model   :   objModel  }));
          this.insertView(".accordionView", new obj.Views.content  ({ model   :   objModel  }));
        }
      }
    })

  });

  //Creating a model with a collection of exportStep
  var exportStepModel           = Backbone.Model.extend();

  //Creating final exportStep class
  var exportStep                = _.extend({}, RegularStep, {
    objClass    : "exportStep",
    Views       : exportStepViews,
    Model       : exportStepModel
  });

  // Required, return the module for AMD compliance
  return exportStep;

});